import { FETCH_FAQ } from './constants'

const initialState = {
  devices: [],
  isFetching: true
}

export default function freeNavReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAQ.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_FAQ.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        devices: action.devices
      }
    }
    default: {
      return state
    }
  }
}
